export const ACCESSIBILITY_SETTINGS_PATH = '/accessibility';

export const ACCESSIBILITY_LOCAL_STORAGE_KEY = 'meteor:accessibility';

export type AccessibilityOptions = {
    reduceMotion: boolean;
};

export const ACCESSIBILITY_DEFAULT_VALUES: AccessibilityOptions = {
    reduceMotion: false,
};
